/**
* DevExpress Analytics (widgets\filtereditor\helpers\_helper.js)
* Version:  23.1.7
* Build date: Dec 11, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { getLocalization } from '../../../property-grid/localization/localization_utils';
export function initDisplayText(object) {
    object.displayText = getLocalization(object.name, object.localizationId);
}
